import { IdCard, Grid3x3, History, ListChecks } from 'lucide-react';

// The patient workspace's SECTION SET — one list, three consumers.
//
// The desktop surface renders it as a `SegmentedControl`, the mobile surface as
// a sticky `SectionNav`, and `index.jsx` validates the `:tab` URL segment
// against it. Those were two hand-kept lists once, and they DRIFTED: چارت دندان
// was added to the tabs while the route whitelist still read
// ['summary','history'], so `/patients/<id>/chart` silently rendered خلاصه and
// the odontogram was unreachable by URL. Clicking the tab worked, which is why
// it survived review.
//
// `icon` is only read by the mobile strip; the desktop control is label-only.
// The value keys ARE the URL segments — renaming one is a URL change.

export const PATIENT_SECTIONS = (t) => [
  { value: 'summary', label: t('patient.tabs.summary'), Icon: IdCard },
  { value: 'chart', label: t('patient.tabs.chart'), Icon: Grid3x3 },
  // طرح درمان outside a visit: what was agreed with this patient and what is
  // left of it. Between appointments — at reception, on the phone, before a
  // recall — the plan was reachable from nowhere.
  { value: 'plan', label: t('patient.tabs.plan'), Icon: ListChecks },
  { value: 'history', label: t('patient.tabs.history'), Icon: History },
];

/** The section ids, without needing a translator. `index.jsx`'s URL whitelist. */
export const PATIENT_SECTION_IDS = ['summary', 'chart', 'plan', 'history'];

/** The segment that is omitted from the URL, and the fallback for an unknown one. */
export const DEFAULT_PATIENT_SECTION = 'summary';

export default PATIENT_SECTIONS;
